import TeamData from '../../data/TeamData'
import ListSelect from '../ListSelect/ListSelect'
import {
  UPDATE_SELECTED_TEAM,
  useFilterUpdate
} from '../../contexts/FilterContext'

const TeamFilter = ({ selectedTeam }) => {
  const filterDispatch = useFilterUpdate()

  const teams = TeamData.map((team) => ({
    value: team.team_id,
    displayText: team.team_name
  })).sort((a, b) => (a.displayText > b.displayText ? 1 : -1))

  return (
    <ListSelect
      options={teams}
      label="Team"
      selectedValue={selectedTeam}
      onChange={(value) =>
        filterDispatch({ type: UPDATE_SELECTED_TEAM, payload: value })
      }
    />
  )
}

export default TeamFilter
